import Mn from 'backbone.marionette';
import { MessagingConfig } from 'messaging/models/config';
import { MessageCreationView } from 'messaging/views/layout';
import { MessageModel } from 'messaging/models/message';


const MessageDialogView = Mn.LayoutView.extend({
  template: require('names/templates/messaging.html'),
  ui: {
    buttonClose: '.button-close'
  },
  triggers: {
    'click @ui.buttonClose': 'close'
  },

  regions: {
    messaging: '.messaging-hook'
  },

  initialize(){
    this.config = new MessagingConfig({
      has_contacts: false,
      has_sms: true
    });

    this.config.fetch();
    this.hasFetchedConfig = false;
    this.listenTo(this.config, 'sync', () => {
      this.hasFetchedConfig = true;
      this.render();
    });
  },

  templateHelpers(){
    return {
      has_joinos: this.config.get('has_joinos'),
      has_sms: this.config.get('has_sms'),
      has_loaded: this.hasFetchedConfig
    };
  },

  onClose(){
      this.modal.close();
  },

  onRender(){
    if(this.hasFetchedConfig){
      let view = new MessageCreationView({
        model: new MessageModel({
          contacts: this.getOption('filter')
        }),
        contact_count: this.getOption('contact_count'),
        config: this.config
      });
      this.showChildView('messaging', view);
      this.listenTo(view, 'saving', () => {
        this.modal.close();
      });
    }
  }
});

export default MessageDialogView;



// WEBPACK FOOTER //
// ./names/views/message.js